import { MainNav } from './main-nav';

export class Header {
    async init({ store }) {
        const mainNav = new MainNav();
        await mainNav.init(store);
    }
} 